module.exports = __webpack_public_path__ + "static/media/90.c301b857.jpg";